import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useMainContext } from '@/context/main-context';
import { formatDate } from '@/lib/utils';
import { Calendar, Clock, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Badge } from '../ui/badge';

function GroupHeader({ group }) {
  const { teachers, courses } = useMainContext();

  console.log(group);

  const teacher = teachers.filter((item) => item.id === group.teacherId)[0]
    ?.fullName;

  const dayMap = {
    monday: 'Du',
    tuesday: 'Se',
    wednesday: 'Chor',
    thursday: 'Pay',
    friday: 'Jum',
    saturday: 'Shan',
    sunday: 'Yak',
  };

  const getDayTypeLabel = (type) => {
    switch (type) {
      case 'odd':
        return {
          label: 'Toq kunlar',
          tooltip: 'Du - Chor - Jum',
          color:
            'bg-orange-100 text-orange-600 hover:bg-orange-100/80 dark:bg-orange-500 dark:hover:bg-orange-500/80 dark:text-white',
        };
      case 'even':
        return {
          label: 'Juft kunlar',
          tooltip: 'Se - Pay - Shan',
          color:
            'bg-purple-100 text-purple-600 hover:bg-purple-100/80 dark:bg-purple-500 dark:hover:bg-purple-500/80 dark:text-white',
        };
      case 'every_day':
        return {
          label: 'Har kuni',
          tooltip: 'Har kuni',
          color:
            'bg-green-100 text-green-600 hover:bg-green-100/80 dark:bg-green-500 dark:hover:bg-green-500/80 dark:text-white',
        };
      default:
        return {
          label: 'Custom',
          tooltip: '',
          color:
            'bg-blue-100 text-blue-600 hover:bg-blue-100/80 dark:bg-blue-500 dark:hover:bg-blue-500/80 dark:text-white',
        };
    }
  };
  const dayType = getDayTypeLabel(group.dayType);

  const customDays =
    Array.isArray(group.weekDays) && group.weekDays.length > 0
      ? group.weekDays.map((d) => dayMap[d] || d.slice(0, 2)).join(' - ')
      : '';

  return (
    <div className="space-y-2 py-4 w-full border-b border-border">
      <div className="flex items-center gap-2">
        <h1 className="text-xl md:text-2xl font-semibold whitespace-nowrap truncate">
          {courses.filter((item) => item.id === group.courseId)[0]?.courseTitle}
        </h1>
        <span className="text-base text-muted-foreground mt-1">
          #{group.groupNumber}
        </span>
        <div
          className={`flex items-center gap-2 text-xs mt-1 md:text-sm ${
            group.status ? 'text-green-500' : 'text-red-500'
          }`}
        >
          <div className="rounded-full w-1.5 h-1.5 bg-green-500" />
          <span>{group.status ? 'Aktiv' : 'Tugatildi'}</span>
        </div>
      </div>
      <div className="flex items-center gap-3 md:gap-5 overflow-x-auto">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <div className="">
                <Badge
                  variant={
                    group.selectedDay === 'odd'
                      ? 'odd'
                      : group.selectedDay === 'even'
                      ? 'even'
                      : 'every'
                  }
                  className={`flex items-center gap-1`}
                >
                  <Clock className="h-4 w-4" />

                  <span>
                    {group.timeInDay
                      ? group.timeInDay
                      : `${group.from || ''} - ${group.to || ''}`}
                  </span>
                </Badge>
              </div>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="text-xs font-medium text-accent-foreground">
                {group.dayType === 'custom' ? customDays : dayType.label}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <div className="flex items-center gap-1">
          <User className="w-4 h-4" />
          <Link
            to={teacher ? `/teachers/${group?.teacherId}` : null}
            className="inline-flex"
          >
            <span
              className={
                teacher
                  ? 'hover:underline whitespace-nowrap'
                  : 'cursor-text whitespace-nowrap'
              }
            >
              {teacher ? teacher : 'Ustoz tanlanmagan'}
            </span>
          </Link>
        </div>

        <div className="flex items-center gap-1 text-xs md:text-sm text-muted-foreground">
          <Calendar className="w-4 h-4" />
          <span>{formatDate(group.startDate)}</span>
        </div>
      </div>
    </div>
  );
}

export default GroupHeader;
